export default __webpack_public_path__ + "static/media/logo3.74c1cbc7.png";